export type SortConfig = {
    key: string | null;
    direction: 'asc' | 'desc';
  };

export type FilterState = {
    selectedStatus: string[];
    selectedBroker: string[];
    sortConfig: SortConfig;
    searchFilters: { brokers: string[]; statuses: string[] };
  };

export const initialState: FilterState = {
    selectedStatus: [],
    selectedBroker: [],
    sortConfig: { key: null, direction: 'asc' },
    searchFilters: { brokers: [], statuses: [] },
};

export type FilterAction =
  | { type: 'SET_STATUS'; payload: string[] }
  | { type: 'SET_BROKER'; payload: string[] }
  | { type: 'SET_SORT'; payload: SortConfig }
  | { type: 'SET_FILTERS'; payload: { brokers: string[]; statuses: string[] } };

export const filterReducer = (state: FilterState, action: FilterAction): FilterState => {
    switch (action.type) {
        case 'SET_STATUS':
        return { ...state, selectedStatus: action.payload };
        case 'SET_BROKER':
        return { ...state, selectedBroker: action.payload };
        case 'SET_SORT':
        return { ...state, sortConfig: action.payload };
        case 'SET_FILTERS':
        return { ...state, searchFilters: action.payload };
        default:
        return state;
    }
};
